import PageSection from '../../../Constants&Theme/PageSection'
import { DataGridPro, GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { Box } from '@mui/material'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import SaleItemsCartDGFooter from './SaleItemsCartDGFooter'
import { sampleSaleCols } from '../SharedItems/SampleSaleCols'
import { useLocalStorage } from 'usehooks-ts'

function SaleItemsCart() {
  const [selection, setSelection] = useState<GridRowSelectionModel>([])
  const [cart, setCart] = useLocalStorage('BioBankShoppingCart', [])
  if (cart.length < 1) {
    return (
      <Navigate
        to={'..'}
        replace
      />
    )
  }
  return (
    <Box sx={{ maxWidth: 'xl', width: 1 }}>
      <PageSection title={'View Cart'}>
        <DataGridPro
          checkboxSelection
          rowSelectionModel={selection}
          onRowSelectionModelChange={setSelection}
          sx={{ width: 1 }}
          autoHeight
          columns={sampleSaleCols}
          rows={cart}
          slots={{
            footer: SaleItemsCartDGFooter as any,
          }}
          slotProps={{
            footer: {
              cart,
              setCart,
              selection,
              setSelection,
            } as any,
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                Price: false,
              },
            },
          }}
        />
      </PageSection>
    </Box>
  )
}

export default SaleItemsCart
